exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".country-phone-menu{overflow:visible!important}.country-phone-menu .country-phone-menu__list{max-height:320px;overflow-y:auto}.country-trigger.v-btn{display:inline-flex!important;height:42px!important;min-height:42px!important;overflow:visible!important}.country-trigger.v-btn .v-btn__content{display:inline-flex!important;align-items:center!important;height:100%!important;overflow:visible!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b022500","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/shared/CountryPhoneInput.vue
// module id = 495
// module chunks = 0